"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const trans_1 = require("@common/tsutils/trans");
let WidgetTrackingGrid = class WidgetTrackingGrid extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.orientation = 'v';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get rasterWidgets() {
        return this.widgets.map((wd) => {
            let completed = false;
            if (wd.num_pending <= 0) {
                completed = true;
            }
            return Object.assign(Object.assign({}, wd), { title: (0, trans_1.trans)('tracking.life_cycles.' + wd.slug + '.pending.title'), subtitle: (0, trans_1.trans)('tracking.life_cycles.' + wd.slug + '.pending.sub'), entity: (0, trans_1.trans)('tracking.life_cycles.' + wd.slug + '.pending.entity'), completed: completed });
        });
    }
    buildDescription(t) {
        if (t.num_pending === 0) {
            return 'No need to ' + t.name;
        }
        else {
            return t.name;
        }
    }
    launchWidget(s) {
        this.$emit('launchwidget', s);
    }
    get hasTasks() {
        const ixTask = this.widgets.findIndex((w) => w.num_pending > 0);
        if (ixTask === -1)
            return false;
        return true;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], WidgetTrackingGrid.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], WidgetTrackingGrid.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], WidgetTrackingGrid.prototype, "widgets", void 0);
WidgetTrackingGrid = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            WidgetTracking: bmk_ui_framework_1.WidgetTracking,
            PageHeading: bmk_ui_framework_1.PageHeading,
            Yield: bmk_ui_framework_1.Yield,
        },
    })
], WidgetTrackingGrid);
exports.default = WidgetTrackingGrid;
